import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { AddSignatureDialogComponent } from './add-signature-dialog/add-signature-dialog.component';
import { ContractsListDialogModule } from './contract-list-modal/contracts-list-dialog.module';
import { ContractPreviewDialogComponent } from './contract-preview-dialog/contract-preview-dialog.component';
import { ContractTemplateEditorComponent } from './contract-template-editor/contract-template-editor.component';
import { ContractsDialogComponent } from './contracts-dialog.component';
import { PlanSelectionComponent } from './plan-selection/plan-selection.component';
import { StandaloneContractDialogComponent } from '../standalone-contract-dialog/standalone-contract-dialog.component';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { PartnerService } from '../../../partners/crud-service';

@NgModule({
  declarations: [
    ContractsDialogComponent,
    AddSignatureDialogComponent,
    PlanSelectionComponent,
    ContractPreviewDialogComponent,
    ContractTemplateEditorComponent,
    StandaloneContractDialogComponent,
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    MatDividerModule,
    MatTooltipModule,
    MatExpansionModule,
    DialogContainerModule,
    MatTabsModule,
    MatSortModule,
    MatPaginatorModule,
    MatChipsModule,
    AngularMaterialModule,
    FieldsModule,
    NgxChartsModule,
    ContractsListDialogModule
  ],
  exports: [
    ContractsDialogComponent,
    PlanSelectionComponent,
    StandaloneContractDialogComponent
  ],
  providers: [
    DatePipe,
    AuthService,
    PartnerService
  ]
})
export class ContractDialogModule { }
